export default __webpack_public_path__ + "static/media/33.7c2f5bed.png";